export default __webpack_public_path__ + "static/KylieGates-6381cbca23d1d9f04b07dba17789baa1.png";